module.exports = __webpack_public_path__ + "img/different.69e83664.png";